export const investmentPlans = [
    {
      name: "Basic Plan",
      image: "sec1.png",
      price: "$200",
      amount: 200, // Added for Trade component
      duration: 3, // days (used directly)
      durationDisplay: "3 days", // For display
      profit: 75, // For Trade component
      hardware: "2x CPU Cores | 1x GPU (NVIDIA T4)",
      efficiency: "75% Uptime",
      chains: "Eth, BSC, Polygon",
      tps: "Up to 250 TPS",
      maxTps: 250, // tps added directly for calculations
      specs: [
        "4GB DDR4 RAM",
        "100GB SSD Storage",
        "1Gbps Network",
        "Basic Cooling System"
      ]
    },
    {
      name: "Standard Plan",
      image: "sec2.png",
      price: "$1,000",
      amount: 1000,
      duration: 5,
      durationDisplay: "5 days",
      profit: 85,
      hardware: "4x CPU Cores | 2x GPU (NVIDIA RTX 3060)",
      efficiency: "85% Uptime",
      chains: "Eth, Sol, Avalanche",
      tps: "Up to 850 TPS",
      maxTps: 850,
      specs: [
        "16GB DDR4 RAM",
        "500GB NVMe SSD",
        "2.5Gbps Network",
        "Liquid Cooling"
      ]
    },
    {
      name: "Premium Plan",
      image: "sec3.png",
      price: "$3,000",
      amount: 3000,
      duration: 1,
      durationDisplay: "1 day",
      profit: 94,
      hardware: "8x CPU Cores | 4x GPU (NVIDIA RTX 4090)",
      efficiency: "94% Uptime",
      chains: "Eth, Sol, Sui",
      tps: "Up to 2,100 TPS",
      maxTps: 2100,
      specs: [
        "32GB DDR5 RAM",
        "1TB NVMe SSD",
        "10Gbps Network",
        "Enterprise Cooling"
      ]
    },
    {
      name: "Special Plan",
      image: "sec1.png",
      price: "$200",
      amount: 200, // Added for Trade component
      duration: 7, // days (used directly)
      durationDisplay: "7 days", // For display
      profit: 75, // For Trade component
      hardware: "2x CPU Cores | 1x GPU (NVIDIA T4)",
      efficiency: "45% Uptime",
      chains: "Eth, BSC, Polygon",
      tps: "Up to 45 TPS",
      maxTps: 45, // tps added directly for calculations
      specs: [
        "16GB DDR4 RAM",
        "128GB SSD Storage",
        "5Gbps Network",
        "Liquid Cooling System"
      ]
    }
  ];

  